import { IconButton, Stack } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import { isComponentDisabledForUpdates } from "../../pages/login/login_utils";

import { CollapsableCard } from "./collapsable_card";
import { TOOLTIPS_EN } from "../../enums/tooltip_enum_EN";

export function EditableCard({
  tooltip,
  title,
  editing,
  editable,
  editActionIcon = <EditIcon />,
  handleEdit,
  handleCancel,
  handleSave,
  permissionMap,
  required_privilege,
  startCollapsed = false,
  blockDuringSturing,
  ...props
}) {
  const EditButton = ({ editing }) => {
    if (isComponentDisabledForUpdates(permissionMap, required_privilege.getPrivilegeKey())) {
      return (
        <IconButton disabled={true} title={TOOLTIPS_EN.INSUFFICIENT_RIGHTS_TO_EDIT}>
          {editActionIcon}
        </IconButton>
      );
    } else {
      if (editing) {
        return (
          <Stack direction="row" spacing={1}>
            <IconButton onClick={handleSave}>
              <SaveIcon />
            </IconButton>
            <IconButton onClick={handleCancel}>
              <CancelIcon />
            </IconButton>
          </Stack>
        );
      }
      return <IconButton onClick={handleEdit}> {editActionIcon}</IconButton>;
    }
  };

  return (
    <CollapsableCard
      tooltip={tooltip}
      startCollapsed={startCollapsed}
      title={title}
      rightAdornment={editable && <EditButton editing={editing} />}
      {...props}
    >
      <Stack direction="column" mx={1} mt={1} mb={1}>
        {props.children}
      </Stack>
    </CollapsableCard>
  );
}
